import { useContext } from 'react';
import { toast } from 'react-toastify';
import { Spinner } from '@ds';
import { Form } from '@ui';
import { AuthContext } from '@lp/core/auth';
import { SchedulerSettingsSubmitRow } from '@lp/features/Scheduler/components';
import { CSSchedulerSettingsDeductionRulesFormType } from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/types';
import { CSSchedulerSettingsDeductionRulesForm } from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/components';
import {
  csSchedulerSettingsDeductionRulesFormSchema,
  getDefaultCSSchedulerDeductionRulesValues,
  toCSDeductionShiftRulesSettings,
} from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/config';
import {
  useCSSchedulePeriodDeductionShiftRulesQuery,
  useCSSetSchedulePeriodDeductionShiftRulesMutation,
} from '@/queries/resource/schedule';
import { retrieveUnifiedError } from '@/api/utils';
import { SchedulerPermissions } from '@/permissions';

export const CSSchedulerSettingsDeductionRulesTab = () => {
  const { checkPermission } = useContext(AuthContext);
  const { data } = useCSSchedulePeriodDeductionShiftRulesQuery();
  const { mutateAsync, isPending } = useCSSetSchedulePeriodDeductionShiftRulesMutation();

  const hasWritePermissions = checkPermission(SchedulerPermissions.CSSchedulesSettingsRulesWrite);

  const handleSubmit = async (formData: CSSchedulerSettingsDeductionRulesFormType) => {
    try {
      await mutateAsync(toCSDeductionShiftRulesSettings(formData));
      toast.success(`Deduction Rules updated successfully`);
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  return (
    <div className="flex flex-col">
      {data ? (
        <Form<CSSchedulerSettingsDeductionRulesFormType>
          defaultValues={getDefaultCSSchedulerDeductionRulesValues(data)}
          schema={csSchedulerSettingsDeductionRulesFormSchema}
          onSubmit={handleSubmit}
        >
          <CSSchedulerSettingsDeductionRulesForm isReadOnly={!hasWritePermissions} />
          <SchedulerSettingsSubmitRow backPath="/schedule/cs" isLoading={isPending} isReadOnly={!hasWritePermissions} />
        </Form>
      ) : (
        <Spinner />
      )}
    </div>
  );
};
